import React, { Component } from "react"
import moment from "moment"
import Config from 'config'
import { connect } from 'react-redux'

import { A, Div, H5, Span } from "@driftt/tide-core"
import { Icon } from '@driftt/tide-icons'
import { getUserById } from "api/conversations"

const mapStateToProps = state => ({
  inboxId: state.embed.configuration.inboxId
})

class VoiceCallEvent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      duration: null,
      agentName: null
    };
  }

  componentDidMount() {
    this.getDurationString();
    this.getAgentName();
  }

  getDurationString = () => {
    const { event } = this.props;

    const start = parseInt(event.body.attributes.event.startedAt);
    const end = parseInt(event.body.attributes.event.endedAt);

    this.setState({
      duration: this.formatDuration(end - start)
    });
  };

  formatDuration = (milliseconds) => {
    const minutes = Math.floor(milliseconds / 60000)
    const seconds = parseInt(((milliseconds % 60000) / 1000).toFixed(0))
    const secondsStr = seconds < 10 ? `0${seconds}` : `${seconds}`
    return {
      display: `${minutes}:${secondsStr}`,
      values: {
        minutes,
        seconds
      }
    }
  }

  getAgentName = async () => {
    const { event } = this.props;
    const agentId = event.body.attributes.event.agentId

    const agent = await getUserById(agentId)
    this.setState({
      agentName: agent.data.name
    })
  }

  render() {
    const { event, name, inboxId: inboxIdFromProps } = this.props;

    const conversationId = event.body.attributes.event.conversationId
    const convoHref = `${Config.INBOX_URL}/${inboxIdFromProps}/conversations/${conversationId}`

    return (
      <Div className="contact-event--container">
        <Div className="contact-event--icon-long">
          <Icon name="answer" width={20} height={20}  />
        </Div>
        <Div className="contact-event--event-description">
          <H5>
            {name} had a phone call
          </H5>
          <Span>{moment(event.body.attributes.event.createdAt).format("MM/DD/YYYY hh:mm A")}</Span>
          <Div className="contact-event--meeting-details">
            Call with {this.state.agentName}
            <br></br>
            {this.state.duration && `Duration: ${this.state.duration.display}`}
          </Div>
          <Div className="contact-event--event-preview">
          <A type="subtle" href={convoHref} target="_blank">
            {
              "View the conversation"
            }
          </A>
        </Div>
        </Div>
      </Div>
    );
  }
}

export default connect(mapStateToProps)(VoiceCallEvent);
